/**
 * Created by tomers on 12/24/2014.
 */
define(function (require) {
    "use strict";

    var Logger = require("logger");
    var BaseModel = require("models/BaseModel");
    var Translator = require("i18n/translator");
    var _ = require("underscore");

    var ListGroupsCollection = require("ui/list/js/collections/ListGroupsCollection");
    var ListItemsCollection = require("ui/list/js/collections/ListItemsCollection");

    var EMPTY_ACTIVE_ITEM = null;
    var DEFAULT_GROUP_ID = ListGroupsCollection.Model.DEFAULT_GROUP_ID;
    var SPECIAL_GROUP_ID = ListGroupsCollection.Model.SPECIAL_GROUP_ID;
    var NEW_ITEM_ENUM = ListItemsCollection.Model.NEW_ITEM_ENUM;
    var NO_ITEMS_ENUM = ListItemsCollection.Model.NO_ITEMS_ENUM;

    var ListModel = BaseModel.extend({
        defaults: function(){
            return {
                selectable: true, // can be selectedItems on the list
                hasCheckbox: true, // has checkbox next to each item
                hasVisibleGroups: false,
                floating: true,
                groupCollapsible: false,
                itemHeight: 33, // height of each item. needed for max-height calculation
                maxShownItems: 10, // max visible items before scroll. needed for max-height calculation. (includes group title...)
                activeItem: EMPTY_ACTIVE_ITEM,
                itemsComparator: true,
                filterValue: "",
                originalItems: new ListItemsCollection(),
                filteredGroupedItems: new ListGroupsCollection(),
                paging: false,
                currentPage: 1,
                pageSize: 20,
                loadMoreOffset: 20, //pxs from the bottom to load the next page
                needLoadMore: false,
                newItemModel: new ListItemsCollection.Model({
                    id: NEW_ITEM_ENUM.ID,
                    group: SPECIAL_GROUP_ID,
                    value: Translator.translate("LEUIComponents.list.newItem.defaultValue"),
                    className: NEW_ITEM_ENUM.CLASS_NAME,
                    visible: false
                }),
                noItemsModel: new ListItemsCollection.Model({
                    id: NO_ITEMS_ENUM.ID,
                    group: SPECIAL_GROUP_ID,
                    value: Translator.translate("LEUIComponents.list.noItems.defaultValue"),
                    className: NO_ITEMS_ENUM.CLASS_NAME,
                    visible: false
                }),
                defaultActions: {
                    add: false,
                    select: false,
                    remove: false
                }
            };
        },

        initialize: function(options) {
            this.logger = Logger.getLogger("List");
            this.logger.info("Initializing List Model", "ListModel:initialize");

            BaseModel.prototype.initialize.call(this,options);
        },

        getSelectable: function() {
            return this.get("selectable");
        },
        setSelectable: function(selectable) {
            this.set("selectable", selectable);
        },
        isSelectable: function() {
            return (this.getSelectable() === true);
        },

        getHasCheckbox: function() {
            return this.get("hasCheckbox");
        },
        setHasCheckbox: function(hasCheckbox) {
            this.set("hasCheckbox", hasCheckbox);
        },
        hasCheckbox: function() {
            return (this.getHasCheckbox() === true);
        },

        getHasVisibleGroups: function() {
            return this.get("hasVisibleGroups");
        },
        setHasVisibleGroups: function(hasVisibleGroups) {
            this.set("hasVisibleGroups", hasVisibleGroups);
        },
        hasVisibleGroups: function() {
            return (this.getHasVisibleGroups() === true);
        },

        getFloating: function() {
            return this.get("floating");
        },
        setFloating: function(floating) {
            this.set("floating", floating);
        },
        isFloating: function() {
            return (this.getFloating() === true);
        },

        getGroupCollapsible: function() {
            return this.get("groupCollapsible");
        },
        setGroupCollapsible: function(groupCollapsible) {
            this.set("groupCollapsible", groupCollapsible);
        },
        isGroupCollapsible: function() {
            return (this.getGroupCollapsible() === true);
        },
        getSingleSelectPerGroup: function() {
            return this.get("singleSelectPerGroup");
        },
        setSingleSelectPerGroup: function(singleSelectPerGroup) {
            this.set("singleSelectPerGroup", singleSelectPerGroup);
        },

        getItemHeight: function() {
            return this.get("itemHeight");
        },
        setItemHeight: function(itemHeight) {
            this.set("itemHeight", itemHeight);
        },

        getMaxShownItems: function() {
            return this.get("maxShownItems");
        },
        setMaxShownItems: function(maxShownItems) {
            this.set("maxShownItems", maxShownItems);
        },

        getPage: function() {
            return this.get("currentPage");
        },
        setPage: function(page) {
            this.set("currentPage", page);
        },

        getPageSize: function() {
            return this.get("pageSize");
        },
        setPageSize: function(pageSize) {
            this.set("pageSize", pageSize);
        },

        getPaging: function() {
            return this.get("paging");
        },
        setPaging: function(paging) {
            this.set("paging", paging);
        },
        isPageable: function() {
            return (this.getPaging() === true);
        },

        getLoadMoreOffset: function() {
            return this.get("loadMoreOffset");
        },
        setLoadMoreOffset: function(loadMoreOffset) {
            this.set("loadMoreOffset", loadMoreOffset);
        },

        isMoreToLoad: function() {
            return (this.get("moreToLoad") === true);
        },

        getActiveItem: function() {
            return this.get("activeItem");
        },
        setActiveItem: function(itemId) {
            if (itemId === this.getActiveItem()) {
                return;
            }

            // unselect the current active item
            var currentActiveItemModel = this._getFilteredGroupedItemModel(this.getActiveItem());
            if (!_.isEmpty(currentActiveItemModel)) {
                currentActiveItemModel.setActive(false);
            }

            // select the wanted one
            var activeItemModel = this._getFilteredGroupedItemModel(itemId);
            if (!_.isEmpty(activeItemModel)) {
                this.set("activeItem", itemId);
                activeItemModel.setActive(true);
            }
            else {
                this.set("activeItem", EMPTY_ACTIVE_ITEM);
            }
        },
        hasActiveItem: function() {
            return (this.getActiveItem() !== EMPTY_ACTIVE_ITEM);
        },

        getGroupsOrder: function() {
            return this.getFilteredGroupedItems().getGroupsOrder();
        },
        setGroupsOrder: function(groupsOrder) {
            this.getOriginalItems().setGroupsOrder(groupsOrder);
            this.getFilteredGroupedItems().setGroupsOrder(groupsOrder);
            this.getFilteredGroupedItems().sort();
        },

        getItemsComparator: function() {
            return this.get("itemsComparator");
        },
        setItemsComparator: function(itemsComparator) {
            this.set("itemsComparator", itemsComparator);
            this.getOriginalItems().setComparator(itemsComparator);
            this.getFilteredGroupedItems().setItemsComparator(itemsComparator);
        },

        setNoItemsModel: function(attr) {
            this.get("noItemsModel").set(attr);

            var noItemsModel = this._getFilteredGroupedItemModel(NO_ITEMS_ENUM.ID);
            if (!_.isEmpty(noItemsModel)) {
                noItemsModel.set(attr);
            }
        },

        setNewItemModel: function(attr) {
            this.get("newItemModel").set(attr);

            var newItemModel = this._getFilteredGroupedItemModel(NEW_ITEM_ENUM.ID);
            if (!_.isEmpty(newItemModel)) {
                newItemModel.set(attr);
            }
        },

        setDefaultActions: function(defaultActions) {
            if (_.has(defaultActions, "add")) {
                this.set("defaultActions.add", defaultActions.add);
            }

            if (_.has(defaultActions, "select")) {
                this.set("defaultActions.select", defaultActions.select);
            }

            if (_.has(defaultActions, "remove")) {
                this.set("defaultActions.remove", defaultActions.remove);
            }
        },
        getDefaultActions: function() {
            return this.get("defaultActions");
        },

        setItems: function(items, options) {
            this.logger.info("List set items", "ListModel:setItems", {items:items, options:options});

            // set the actions on each item
            _.each(items, _.bind(function(item, index) {
                var actions = item.actions || {};
                items[index].actions = _.defaults(actions, this.getDefaultActions());

                items[index].group = item.group || DEFAULT_GROUP_ID;
            }, this));

            if (options && _.isString(options.filter)) {
                this.set("filterValue", options.filter);
            }

            if (_.isArray(items)) {
                this.getOriginalItems().reset(items);
                this.filter();

                if (this.getSingleSelectPerGroup()) {
                    _.each(items, _.bind(function(item, index) {
                        if (item.selected) {
                            this._setGroupItemsState(item.group, !item.selected, [ item.id ]);
                        }
                    }, this));
                }
            }
        },

        getItems: function() {
            var itemsArr = [];

            this.getFilteredGroupedItems().each(function(groupModel) {
                groupModel.getItems().each(function(itemModel) {
                    itemsArr.push(itemModel.toJSON());
                });
            });

            return itemsArr;
        },

        getAllItems: function() {
            var itemsArr = [];

            this.getOriginalItems().each(function(itemModel) {
                itemsArr.push(itemModel.toJSON());
            });

            return itemsArr;
        },

        getFilterValue: function() {
            return this.get("filterValue");
        },
        setFilterValue: function(filterValue, forceFilter) {
            var needToFilter = ((filterValue !== this.getFilterValue()) || forceFilter);
            if (needToFilter) {
                this.set("filterValue", filterValue);
                this.filter();
            }
        },

        filter: function() {
            this.logger.info("List filter", "ListModel:filter");
            var filteredValue = this.getFilterValue();
            var filteredValueLowerCase = filteredValue.toLowerCase();
            var originalItemsCollection = this.getOriginalItems();
            var isExactMatch = false;

            var filteredModelsArr = [];
            _.each(originalItemsCollection.toJSON(), function(itemObj) {
                var itemValueLowerCase = itemObj.value.toLowerCase();
                itemObj.isFilteredByValue = (itemValueLowerCase.indexOf(filteredValueLowerCase) === 0);

                var itemSubTextLowerCase = itemObj.subText.toLowerCase();
                itemObj.isFilteredBySubText = (itemSubTextLowerCase.indexOf(filteredValueLowerCase) === 0);


                if (itemValueLowerCase === filteredValueLowerCase) {
                    isExactMatch = true;
                }

                if (itemObj.isFilteredBySubText || itemObj.isFilteredByValue || itemObj.notAffectedByFilter) {
                    filteredModelsArr.push(itemObj);
                }
            });

            this.logger.debug("List filter data", "ListModel:filter", {filteredValueLowerCase:filteredValueLowerCase, filteredModelsAdd:filteredModelsArr, isExactMatch:isExactMatch});

            this.set("moreToLoad", false);
            if (this.isPageable()) {
                var numOfItemsToShow = this.getPage() * this.getPageSize();
                if (filteredModelsArr.length > numOfItemsToShow) {
                    filteredModelsArr = filteredModelsArr.slice(0, numOfItemsToShow);
                    this.set("moreToLoad", true);
                }
            }

            if (!isExactMatch && !_.isEmpty(filteredValueLowerCase) && this.get("newItemModel").isVisible()) {
                filteredModelsArr.push(this.get("newItemModel").toJSON());
            }

            if (_.isEmpty(filteredModelsArr) && this.get("noItemsModel").isVisible()) {
                filteredModelsArr.push(this.get("noItemsModel").toJSON());
            }
            this._updateFilteredGroupedItems(filteredModelsArr);
        },

        _updateFilteredGroupedItems: function(items) {
            this.logger.info("List update groups and items", "ListModel:_updateFilteredGroupedItems", {items:items});

            var hasVisibleGroups = false;

            _.each(items, _.bind(function(item, index) {
                items[index].filteredValue = this.getFilterValue();
            }, this));

            var groupsObj = _.groupBy(items, "group");
            var groupModelsArr = [];
            _.each(groupsObj, _.bind(function(itemsInGroupArr, groupId) {
                var titleVisible = (groupId !== DEFAULT_GROUP_ID && groupId !== SPECIAL_GROUP_ID);
                hasVisibleGroups = hasVisibleGroups || titleVisible;
                var groupModel = {
                    id: groupId,
                    titleVisible: titleVisible,
                    groupCollapsible: this.isGroupCollapsible(),
                    items: new ListItemsCollection(itemsInGroupArr, {comparator: this.getItemsComparator()})
                };
                groupModelsArr.push(groupModel);
            }, this));

            this.set("hasVisibleGroups", hasVisibleGroups);
            this.setActiveItem(EMPTY_ACTIVE_ITEM);

            this.logger.debug("List group data", "ListModel:_updateFilteredGroupedItems", {groupModelsArr:groupModelsArr});
            this.getFilteredGroupedItems().reset(groupModelsArr);
        },

        addItem: function(item) {
            var actions = item.actions || {};
            item.actions = _.defaults(actions, this.getDefaultActions());
            item.group = item.group || DEFAULT_GROUP_ID;

            this.getOriginalItems().add(item, {merge:true});
            this.filter();
        },

        removeItem: function(itemId) {
            this.getOriginalItems().remove(itemId);
            this.filter();
        },

        getSelectedItems: function() {
            var selectedItemIds = [];
            this.getOriginalItems().each(function(itemModel) {
                if (itemModel.isSelected()) {
                    selectedItemIds.push(itemModel.id);
                }
            });
            return selectedItemIds;
        },

        setSelectedItems: function(itemIds) {
            if (!this.isSelectable()) {
                return;
            }

            // unselect all
            this.unselectAll();

            //select relevant
            _.each(itemIds, _.bind(function(itemId) {
                var originalModel = this._getOriginalItemModel(itemId);
                if (!_.isEmpty(originalModel)) {
                    originalModel.select();
                }

                var filteredModel = this._getFilteredGroupedItemModel(itemId);
                if (!_.isEmpty(filteredModel)) {
                    filteredModel.select();
                }

                if (this.getSingleSelectPerGroup()) {
                    this._setGroupItemsState(originalModel.group, !originalModel.getSelected(), [itemId]);
                }
            }, this));
        },

        selectItem: function(itemId) {
            if (!this.isSelectable()) {
                return;
            }

            var originalModel = this._getOriginalItemModel(itemId);
            if (!_.isEmpty(originalModel)) {
                originalModel.select();
            }

            var filteredModel = this._getFilteredGroupedItemModel(itemId);
            if (!_.isEmpty(filteredModel)) {
                filteredModel.select();
            }

            if (this.getSingleSelectPerGroup()) {
                this._setGroupItemsState(originalModel.getGroup(), !originalModel.getSelected(), [itemId]);
            }
        },

        unselectItem: function(itemId) {
            if (!this.isSelectable()) {
                return;
            }

            var originalModel = this._getOriginalItemModel(itemId);
            if (!_.isEmpty(originalModel)) {
                originalModel.unselect();
            }

            var filteredModel = this._getFilteredGroupedItemModel(itemId);
            if (!_.isEmpty(filteredModel)) {
                filteredModel.unselect();
            }

            if (this.getSingleSelectPerGroup()) {
                this._setGroupItemsState(originalModel.getGroup(), !originalModel.getSelected(), [itemId]);
            }
        },

        unselectAll: function() {
            _.each(this.getSelectedItems(), _.bind(function(itemId) {
                var originalModel = this._getOriginalItemModel(itemId);
                if (!_.isEmpty(originalModel)) {
                    originalModel.unselect();
                }

                var filteredModel = this._getFilteredGroupedItemModel(itemId);
                if (!_.isEmpty(filteredModel)) {
                    filteredModel.unselect();
                }

                if (this.getSingleSelectPerGroup()) {
                    this._setGroupItemsState(originalModel.getGroup(), !originalModel.getSelected(), [itemId]);
                }
            }, this));
        },

        toggleSelection: function(itemId) {
            if (!this.isSelectable()) {
                return;
            }

            var originalModel = this._getOriginalItemModel(itemId);
            if (!_.isEmpty(originalModel)) {
                originalModel.toggleSelection();
            }

            var filteredModel = this._getFilteredGroupedItemModel(itemId);
            if (!_.isEmpty(filteredModel)) {
                filteredModel.toggleSelection();
            }

            if (this.getSingleSelectPerGroup()) {
                this._setGroupItemsState(originalModel.getGroup(), !originalModel.getSelected(), [itemId]);
            }
        },


        getItemModel: function(itemId) {
            return this._getFilteredGroupedItemModel(itemId);
        },

        getOriginalItems: function() {
            return this.get("originalItems");
        },
        getFilteredGroupedItems: function() {
            return this.get("filteredGroupedItems");
        },
        _getOriginalItemModel: function(itemId) {
            return this.getOriginalItems().get(itemId);
        },
        _getFilteredGroupedItemModel: function(itemId) {
            var itemModel = null;
            this.getFilteredGroupedItems().each(function(listGroupModel) {
                var listItemModel = listGroupModel.getItem(itemId);
                if (!_.isEmpty(listItemModel)) {
                    itemModel = listItemModel;
                    return false;
                }
            });
            return itemModel;
        },
        _setGroupItemsState: function(group, enabled, exclude) {
            var ignore = [];

            function manageState(item, index, array) {
                if (-1 === ignore.indexOf(item.id) && _.isFunction(item.setEnabled) && group === (item && _.isFunction(item.getGroup) && item.getGroup())) {
                    item.setEnabled(enabled);
                }
            }

            if (exclude) {
                if (_.isArray(exclude)) {
                    ignore = exclude;
                }
                else {
                    ignore = [ exclude ];
                }
            }

            this.getFilteredGroupedItems().each(function(listGroupModel) {
                var groupItems;
                if (group === listGroupModel.id) {
                    groupItems = listGroupModel.getItems();

                    if (groupItems && groupItems.length) {
                        groupItems.each(manageState);
                    }
                }
            });

            this.getOriginalItems().each(manageState);
        }
    });

    ListModel.EMPTY_ACTIVE_ITEM = EMPTY_ACTIVE_ITEM;
    ListModel.NEW_ITEM_ID = NEW_ITEM_ENUM.ID;
    ListModel.NO_ITEMS_ID = NO_ITEMS_ENUM.ID;

    return ListModel;
});
